import { apiRequest } from "../general.service";
import v1Service from "../v1.service"
const authService = {
    path: `${v1Service.basic}/${v1Service.auth}`,
    methods: {
        getPath: (new_path: string): string => {
            return authService.path + new_path
        },
        login: (body: API.LoginDto,) => {
            return apiRequest<API.APIResponse<API.UserProfile>>(authService.methods.getPath("/login"), "POST", body)
        },
        register: (body: API.RegsiterDto) => {
            return apiRequest<API.APISuccessResponse<API.UserProfile>>(authService.methods.getPath("/register"), "POST", body)
        },
        refresh: () => {
            return apiRequest<API.APIResponse<null>>(authService.methods.getPath("/refresh"), "POST")
        },
        forgetResetPassword: (body: API.ForgetResetPasswordDto) => {
            return apiRequest<API.APIResponse<API.UserProfile>>(authService.methods.getPath("/forgetResetPassword"), "POST", body)
        },
        getVerificationCode: (body: API.GetVerificationCodeDto) => {
            return apiRequest<API.APIResponse<API.GetVerificationCode>>(authService.methods.getPath("/getVerificationCode"), "POST", body)
        },
        logout: () => {
            return apiRequest<API.APIResponse<null>>(authService.methods.getPath("/logout"), "POST")
        },
        deleteAccRequest: (body: API.DeleteAccRequest) => {
            // console.log("deleteAccRequest.body", body)
            return apiRequest<API.APIResponse<API.DeleteAccRequest>>(authService.methods.getPath("/deleteAccRequest"), "POST", body)
        }

    },
    check: {
        user: {
            nickname: { size: 45 },
            email: { size: 55 },
            password: { size: 256 },
            account_status: { size: 10 },
            avatar: { size: 1000 }
        }
    }
};
export default authService;